import { z } from "zod";

export const addFiscalDocumentSchema = z.object({
  number: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  serial: z.string({ message: 'Campo obrigatório' }).min(1, { message: 'Campo obrigatório' }),
  pdf: z.custom().optional().nullable(),
  xml: z.custom().optional().nullable(),
});

export type AddFiscalDocumentValidationSchema = z.infer<typeof addFiscalDocumentSchema>;
